import React, { useEffect, useState } from 'react'
import {
  Grid,
  Button,
  TextField,
  InputLabel,
  Container,
  Paper,
  CircularProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material'
import { useZones } from '../../hooks/useZones'
import { useModal } from '../../hooks/useModal'
import { Modal } from '../_EOS/Modal'
import { PickingValidateZoneModal } from './PickingValidateZoneModal'
import { ApiConfig } from '../../config/api'
import axios from 'axios'
import { useApi } from '../../hooks/useApi'
import { Status } from '../../hooks/useFetchState'
import { SelectPickingRouteModal } from './Modals/SelectPickingRouteModal'
import { PickingRoute } from '../../interfaces/Picking/Picking'
import { PickingRouteRelatedDialogInfo } from './PickingRoutesRelated/PickingRouteRelatedDialogInfo'
import { getPickingRouteRelated, getValidateIsSingleOrderOT } from './api'
import { ApiResponse } from '../../typings/ApiResponse'
import { PickingRoutesRelated } from './PickingRoutesRelated/PickingRouteRelated'
import { eValidationStatus } from '../../enums/eValidationStatus'

interface PickingValidateStartProps {
  handleStartPickingRoute: (field?: string, value?: string) => void
  handlePagination: (updatePage: number) => void
  pickingRouteId: number
  isLoadingButton: boolean
  handleSelectedField: React.Dispatch<React.SetStateAction<string>>
  selectedField: string
  handleSelectedValue: React.Dispatch<React.SetStateAction<string>>
  selectedValue: string
  handleSnackBar: (
    isOpen: boolean,
    message: string,
    status: string,
    duration?: number
  ) => void
  setSingleOrderOT: React.Dispatch<React.SetStateAction<boolean>>
}

export interface PickingZoneResumeInfoDto {
  pickingRouteId: number
  zoneId: number
  zoneName: string
}

const getPickingZone = (referenceId: string) => {
  const url = new URL(`${ApiConfig.PickingRouteApi}/GetPickingZone`)

  url.searchParams.set('referenceId', referenceId)

  return axios.get(url.toString())
}

const getPickingRouteByLpn = (lpn: string) => {
  const url = new URL(`${ApiConfig.PickingRouteApi}/GetPickingRouteByLpn`)

  url.searchParams.set('lpn', lpn)

  return axios.get(url.toString())
}

export const PickingValidateStart: React.FC<PickingValidateStartProps> = ({
  handleStartPickingRoute,
  handlePagination,
  isLoadingButton,
  handleSelectedField,
  selectedField,
  handleSelectedValue,
  selectedValue,
  handleSnackBar,
  setSingleOrderOT
}) => {
  const handleFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedOption = event.target.value as 'pickingRouteId' | 'lpn'
    handleSelectedField(selectedOption)
  }
  const {
    isOpen: OpenModalZone,
    closeModal: CloseModalZone,
    openModal,
    title,
    extendedProps
  } = useModal<PickingZoneResumeInfoDto[]>('searchOrigin')

  const {
    isOpen: filterRouteModalIsOpen,
    closeModal: filterRouteModalcloseModal,
    openModal: filterRouteModalOpenModal,
    title: filterRouteModalTitle,
    extendedProps: filterRouteModalExtendenProps
  } = useModal<PickingRoute[]>('Rutas por LPN')

  const {
    isOpen: isOpenModalRouteRelatedValidate,
    closeModal: CloseRouteRelatedValidate,
    openModal: openModalRouteRelatedValidate,
    extendedProps: extendedRelated
  } = useModal<{ referenceId: string; lpn: string; blockValidation: boolean }>(
    'RouteRelatedValidate'
  )

  const [
    isLoadingValidatePickingRouteRelated,
    setIsLoadingValidatePickingRouteRelated
  ] = useState(false)

  const [allRoutesPickingFinalize, setAllRoutesPickingFinalize] =
    useState<boolean>(false)

  const { callApi: callApiRelatedRoutes } =
    useApi<ApiResponse<PickingRoutesRelated>>()

  const { callApi: callApiValidateSingleOrderOT } = useApi<boolean>()
  const [loadingModalZone, setLoadingModalZone] = useState(false)

  const requestGetPickingZone = (referenceId: string) => {
    setLoadingModalZone(true)
    callApi(getPickingZone(referenceId))
      .then((response: PickingZoneResumeInfoDto[]) => {
        if (response.length > 1) {
          openModal('sm', response, 'Validación')
        } else {
          handleStartPickingRoute(
            'pickingRouteId',
            response[0].pickingRouteId.toString()
          )
          handlePagination(0)
        }
      })
      .catch((error) => {
        handleSnackBar(true, JSON.stringify(error), 'error')
      })
      .finally(() => setLoadingModalZone(false))
  }

  const requestPickingRouteByLpn = (lpn: string) => {
    callApi(getPickingRouteByLpn(lpn))
      .then((response: PickingRoute[]) => {
        if (response.length > 1) {
          filterRouteModalOpenModal(
            'sm',
            response,
            'Seleccionar Ruta de Picking'
          )
        } else if (response.length === 0) {
          handleSnackBar(
            true,
            `No se encontraron rutas para lpn '${lpn}'`,
            'error'
          )
        } else {
          executeStartPickingValidate(response[0].pickingRouteId.toString())
        }
      })
      .catch((error) => {
        handleSnackBar(true, JSON.stringify(error), 'error')
      })
  }

  const validateSingleRoute = (t: any): boolean => {
    if (t?.items?.length === 1) {
      if (t?.items[0]?.pickingRouteStateId !== eValidationStatus.Finished) {
        handleSnackBar(
          true,
          'No puedes validar esta ruta, ya que el picking aún no ha finalizado',
          'error',
          6000
        )
        return false
      }
    }
    return true
  }

  // Metodo que valida primero por la configuración de rutas relacionadas.
  // Al estar activo no se permitira la validación de rutas de picking en pedidos que cuenten con 1 o más rutas pendientes de picking
  const validateRoutesRelated = (
    pickingRouteId: number,
    referenceId?: string,
    lpn?: string
  ) => {
    setIsLoadingValidatePickingRouteRelated(true)
    // configuración activa debe bloquear la validación, si existen rutas relacionadas sin pickear
    if (referenceId || lpn) {
      callApiRelatedRoutes(
        getPickingRouteRelated(pickingRouteId, 0, 100, referenceId, lpn)
      )
        .then((t) => {
          // nueva validación WMSE-3505 si la ruta es única y la ruta se encuentra en estado no finalizado
          if (!validateSingleRoute(t)) return

          // verifica que todas las rutas esten en estado 3 finalizado
          const allRoutesPickingFinalizeRequest = t?.items?.every(
            (item: PickingRoutesRelated) => item.pickingRouteStateId === 3
          )

          // Lee la configuración de bloqueo directamente desde la respuesta de la API (ya resuelta por marca en el backend)
          const blockValidation = t?.items?.[0]?.blockValidation ?? false

          // Abre el dialogo de advertencia si existen rutas de picking sin finalizar. Dependiendo del parametro en las config bloquea o no la validación.
          if (
            allRoutesPickingFinalizeRequest !== undefined &&
            !allRoutesPickingFinalizeRequest
          ) {
            openModalRouteRelatedValidate('md', {
              referenceId: referenceId || '',
              lpn: lpn || '',
              blockValidation
            })
          } else {
            if (referenceId) {
              // en caso que no existan rutas de picking relacionadas se ejecutan los metodos del evento para iniciar la validación
              requestGetPickingZone(referenceId)
            }

            if (lpn) {
              // en caso que no existan rutas de picking relacionadas se ejecutan los metodos del evento para iniciar la validación
              requestPickingRouteByLpn(lpn)
            }
          }

          setAllRoutesPickingFinalize(
            allRoutesPickingFinalizeRequest !== undefined
              ? allRoutesPickingFinalizeRequest
              : true
          )
        })
        .catch((error) => {
          handleSnackBar(true, error, 'error')
        })
        .finally(() => setIsLoadingValidatePickingRouteRelated(false))
    } else {
      // validar si la OT relacionada a la ruta picking tiene un pedido. si tiene mas pedidos no debe mostrar grilla rutas relacionadas.
      callApiValidateSingleOrderOT(getValidateIsSingleOrderOT(pickingRouteId))
        .then((res) => {
          // *si es mono pedido
          if (res) {
            setSingleOrderOT(true)
            // obtiene rutas relacionadas
            callApiRelatedRoutes(
              getPickingRouteRelated(pickingRouteId, 0, 100, referenceId)
            )
              .then((t) => {
                // nueva validación WMSE-3505 si la ruta es única y la ruta se encuentra en estado no finalizado
                if (!validateSingleRoute(t)) return

                // verifica que todas las rutas esten en estado 3 finalizado
                const allRoutesPickingFinalizeRequest = t?.items?.every(
                  (item: PickingRoutesRelated) => item.pickingRouteStateId === 3
                )

                // Abre el dialogo de advertencia si existen rutas de picking sin finalizar. Dependiendo del parametro en las config bloquea o no la validación.
                if (
                  allRoutesPickingFinalizeRequest !== undefined &&
                  !allRoutesPickingFinalizeRequest
                ) {
                  openModalRouteRelatedValidate()
                } else {
                  // en caso que no existan rutas de picking relacionadas se ejecutan los metodos del evento para iniciar la validación
                  executeStartPickingValidate(pickingRouteId.toString())
                }

                setAllRoutesPickingFinalize(
                  allRoutesPickingFinalizeRequest !== undefined
                    ? allRoutesPickingFinalizeRequest
                    : true
                )
              })
              .catch((error) => {
                handleSnackBar(true, error, 'error')
              })
          } else {
            executeStartPickingValidate(pickingRouteId.toString()) // obtiene la ruta picking sin validacion de rutas relacionadas ya que es multi pedido
            setSingleOrderOT(false) // indica que la ot es multipedido. en caso que no se refreque la pantalla y busquen otro id
          }
        })
        .finally(() => setIsLoadingValidatePickingRouteRelated(false))
    }
  }

  const { state, callApi } = useApi()

  const {
    zonesState: { zones },
    getZones
  } = useZones()

  useEffect(() => {
    if (zones?.length === 0) {
      getZones()
    }
  }, [])

  const defineText = (type: string) => {
    let result = ''
    switch (type) {
      case 'pickingRouteId':
        result = 'Ingrese Ruta de Picking a Validar'
        break
      case 'lpn':
        result = 'Ingrese LPN a Validar'
        break
      case 'referenceId':
        result = 'Ingrese ID de Pedido a Validar'
        break
      default:
        break
    }
    return result
  }

  const executeStartPickingValidate = (pickingrouteId?: string) => {
    if (pickingrouteId === undefined) {
      handleStartPickingRoute()
    } else {
      handleStartPickingRoute('pickingRouteId', pickingrouteId)
    }

    handlePagination(0)
  }

  return (
    <Container maxWidth='xl'>
      <Paper elevation={2} style={{ padding: '30px' }}>
        <Grid
          container
          direction='row'
          spacing={2}
          justifyContent='center'
          alignItems='center'
          style={{ marginTop: '50px' }}
        >
          <Grid
            container
            spacing={2}
            direction='column'
            alignItems='center'
            justifyContent='center'
          >
            <Grid item xs={12}>
              <FormControl component='fieldset' disabled={isLoadingButton}>
                <FormLabel component='legend'>
                  Seleccione el campo por el cual buscar:
                </FormLabel>
                <RadioGroup
                  aria-label='Field'
                  name='field'
                  value={selectedField}
                  onChange={handleFieldChange}
                  row
                >
                  <FormControlLabel
                    value='pickingRouteId'
                    control={<Radio />}
                    label='ID Ruta de Picking'
                  />
                  <FormControlLabel
                    value='lpn'
                    control={<Radio />}
                    label='LPN'
                  />
                  <FormControlLabel
                    value='referenceId'
                    control={<Radio />}
                    label='ID de Pedido'
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={10}>
              <InputLabel style={{ marginBottom: 10 }}>
                {defineText(selectedField)}
              </InputLabel>

              <TextField
                disabled={
                  isLoadingButton || isLoadingValidatePickingRouteRelated
                }
                id='pickingRouteId'
                name='pickingRouteId'
                label='Capture para confirmar'
                autoFocus
                autoComplete='off'
                value={selectedValue}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleSelectedValue(event.target.value.trim())
                }
                type={selectedField === 'pickingRouteId' ? 'number' : 'text'}
                onKeyPress={(evt: any) => {
                  const keyCode = evt
                    ? evt.which
                      ? evt.which
                      : evt.keyCode
                    : evt.keyCode
                  if (keyCode === 13) {
                    // Verificar si el campo está vacío o solo contiene espacios
                    if (!selectedValue || selectedValue.trim() === '') {
                      return // No hacer nada si está vacío
                    }

                    if (selectedField === 'referenceId') {
                      validateRoutesRelated(0, selectedValue)
                    } else if (selectedField === 'lpn') {
                      validateRoutesRelated(0, undefined, selectedValue)
                    } else {
                      validateRoutesRelated(parseInt(selectedValue, 10))
                    }
                  }
                }}
              />
              <Button
                type='button'
                variant='contained'
                color='primary'
                style={{ marginLeft: 10, marginTop: 10 }}
                onClick={() => {
                  if (selectedField === 'referenceId') {
                    validateRoutesRelated(0, selectedValue)
                  } else if (selectedField === 'lpn') {
                    validateRoutesRelated(0, undefined, selectedValue)
                  } else {
                    validateRoutesRelated(parseInt(selectedValue, 10))
                  }
                }}
                startIcon={
                  isLoadingButton || isLoadingValidatePickingRouteRelated ? (
                    <CircularProgress size='0.9rem' />
                  ) : undefined
                }
                disabled={
                  isLoadingButton ||
                  !selectedValue ||
                  isLoadingValidatePickingRouteRelated ||
                  isOpenModalRouteRelatedValidate // permanece inactivo si el dialogo de las rutas relacionadas esta abierto
                }
              >
                {'Validar'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Modal
        open={OpenModalZone}
        title={title}
        onClose={CloseModalZone}
        loading={extendedProps === undefined}
      >
        {extendedProps && (
          <PickingValidateZoneModal
            pickingZoneResumeInfoDto={extendedProps}
            validateRoutesRelated={executeStartPickingValidate}
            loadingModal={loadingModalZone}
            setLoadingModalZone={setLoadingModalZone}
          />
        )}
      </Modal>
      <Modal
        open={filterRouteModalIsOpen}
        title={filterRouteModalTitle}
        onClose={filterRouteModalcloseModal}
        loading={state.status === Status.Loading}
      >
        {filterRouteModalExtendenProps && (
          <SelectPickingRouteModal
            pickingRouteIds={filterRouteModalExtendenProps?.map(
              (el) => el.pickingRouteId
            )}
            validateRoutesRelated={validateRoutesRelated}
            loading={isLoadingButton}
          />
        )}
      </Modal>

      <Modal
        maxWidth={'md'}
        open={isOpenModalRouteRelatedValidate}
        title={''}
        onClose={CloseRouteRelatedValidate}
      >
        <PickingRouteRelatedDialogInfo
          allRoutesPickingFinalize={allRoutesPickingFinalize}
          pickingRouteId={parseInt(selectedValue, 10)}
          closeModal={CloseRouteRelatedValidate}
          executeStartPickingValidate={executeStartPickingValidate}
          requestPickingRouteByLpn={requestPickingRouteByLpn}
          referenceId={extendedRelated?.referenceId}
          lpn={extendedRelated?.lpn}
          openModalZone={requestGetPickingZone}
        />
      </Modal>
    </Container>
  )
}
